// extracted by mini-css-extract-plugin
export default {"complete":"Complete-module--complete--3da4e","logo":"Complete-module--logo--691b2","links":"Complete-module--links--44879"};